import { render, staticRenderFns } from "./instructionFolderTable.vue?vue&type=template&id=0f834c2b"
import script from "./instructionFolderTable.vue?vue&type=script&lang=js"
export * from "./instructionFolderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports